<template>
	<div class="photos-view" @dragenter.prevent="dragenter" @dragleave.prevent="dragleave" @drop.prevent="drop" @dragover.prevent="">
		<div class="drag" v-show="value.length == 0">Træk billeder hertil</div>
		<div class="photo" v-for="(img, i) in value" :key="i" :style="{ backgroundImage: `url(${img.src})` }" @click="open(i)">
			<div class="cover make" @click.stop="remove(i)">Slet</div>
		</div>
	</div>
</template>

<script>
	import gallery from '../../utils/gallery';

	export default {
		data() {
			return {
				files: []
			};
		},
		props: {
			value: {
				type: Array,
				required: true
			}
		},
		computed: {
			_images() {
				return this.value.map((item) => {
					return {
						src: 	item.src,
						info:	item.tag || ''
					};
				});
			}
		},
		methods: {
			dragenter(event) {
				console.log('enter', event);
			},
			dragleave(event) {
				console.log('leave', event);
			},
			async drop(event) {
				console.log('drop', event);

				console.log('FILES', this.files);

				const r = await Promise.all(this.files.concat(Array.prototype.slice.call(event.dataTransfer.files).map(async (val) => {
					return {
						file: val,
						src: await new Promise((resolve) => {
							var reader = new FileReader();

							reader.onload = (event) => {
								console.log('resolved!!');
								resolve(event.target.result);
							};

							reader.readAsDataURL(val);
						})
					};
				})));

				this.$emit('input', this.value.concat(r));
			},
			remove(idx) {
				/*var value = Array.from(this.value);
				value.splice(idx, 1);
				this.$emit('input', value);*/
				var r = Array.from(this.value);
				r.splice(idx, 1);
				this.$emit('input', r);
			},
			open(idx) {
				gallery.open(this._images, idx);
			},
			hide() {
				this.$store.dispatch('gallery/hide');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.photos-view {
		min-height: 300px;

		& > .photo {
			display: inline-block;
			width: 200px;
			height: 150px;
			margin: 0 10px 10px 0;
			background-size: cover;
			cursor: pointer;
			position: relative;
			overflow: hidden;
			background-position: center center;

			& > .cover {
				position: absolute;
				left: 0;
				bottom: 0;
				width: 100%;
				text-align: center;
				background-color: rgba(248, 0, 0, 0.753);
				color: white;
				line-height: 20px;
				text-transform: uppercase;
				font-size: 12px;
				transform: translateY(10px);
				opacity: 0;
				transition: 250ms ease-in-out all;
			}

			&:hover {
				& > .cover {
					transform: translateY(0);
					opacity: 1;
				}
			}
		}

		& > .drag {
			text-align: center;
			line-height: 300px;
		}
	}
</style>